<template>
  <div class="openingSteps tw-w-full tw-bg-bgMain  tw-py-24">
    <div
      class="tab-view-container medium-item tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <p class="main-title">
        <span>{{ $t("3步") }}{{ $t("开启您的区块链转型") }}</span>
      </p>
      <span class="sub-title">
        {{ $t("从沟通方案确认到开发上线，提供高效、透明、可靠的区块链开发服务") }}
      </span>
      <div class="tw-flex tw-flex-col tw-gap-4">
        <div
          v-for="(item, index) in stepsList"
          :key="index"
          class="step-card tw-relative tw-flex"
          style="
            background: #FFFFFF;
            box-shadow: 0px 4px 40px 0px rgba(29,95,235,0.1);
            border-radius: 20px;
            padding: 20px;
            width: 100%;
            min-height: 226px;
          "
        >
          <div 
            class="tw-relative tw-z-10 tw-flex tw-flex-col"
            style="width: 65%; padding-right: 10px;"
          >
            <div
              class="tw-flex tw-items-center tw-justify-center tw-text-white tw-font-bold"
              style="
                width: 44px;
                height: 34px;
                background: linear-gradient(90deg, #4077F8 0%, #3D4BDF 100%);
                border-radius: 76px;
                font-size: 18px;
              "
            >
              {{ String(index + 1).padStart(2, '0') }}
            </div>

            <h3
              class="tw-font-semibold tw-mt-3"
              style="
                font-weight: 600;
                font-size: 18px;
                color: #111111;
              "
            >
              {{ $t(item.title) }}
            </h3>

            <div
              style="
                width: 20px;
                height: 0px;
                border-radius: 0px;
                border: 2px solid #4077F8;
                margin-top: 8px;
                margin-bottom: 12px;
              "
            ></div>

            <p
              class="tw-flex-1"
              style="
                font-weight: 500;
                font-size: 10px;
                color: #666666;
                line-height: 15px;
              "
            >
              {{ $t(item.description) }}
            </p>

            <div class="tw-flex tw-gap-2 tw-mt-auto tw-flex-wrap">
              <div
                v-for="(btn, btnIndex) in item.buttons"
                :key="btnIndex"
                class="tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-transition-all hover:tw-shadow-md"
                style="
                  width: 80px;
                  height: 22px;
                  background: #FFFFFF;
                  border-radius: 100px;
                  border: 1px solid #E9E9E9;
                  flex-shrink: 0;
                "
              >
                <img
                  src="@/assets/home/right.png"
                  alt=""
                  class="tw-mr-0.5"
                  style="width: 12px; height: 12px;"
                />
                <span
                  style="
                    font-weight: 500;
                    font-size: 10px;
                    color: #4077F8;
                    white-space: nowrap;
                  "
                >
                  {{ $t(btn) }}
                </span>
              </div>
            </div>
          </div>

          <img
            :src="item.bgImg"
            alt=""
            class="tw-absolute tw-bottom-0 tw-right-0"
            style="
              width: 45%;
              max-width: 200px;
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import step01 from "@/assets/home/step01.png";
import step02 from "@/assets/home/step02.png";
import step03 from "@/assets/home/step03.png";

export default {
  name: "openingSteps",
  props: {},
  components: {},
  data() {
    return {
      isVisible: false,
      currentStep: 0,
      stepsList: [
        {
          bgImg: step01,
          title: "咨询对话",
          description: "深入沟通业务需求、应用场景与核心功能，明确项目方向，输出可落地的区块链解决方案。",
          buttons: ["需求梳理", "方案诊断"]
        },
        {
          bgImg: step02,
          title: "报价签约",
          description: "根据功能范围与开发周期透明报价，明确付款方式、交付节点与合同内容，合作清晰推进。",
          buttons: ["透明报价", "合同确认"]
        },
        {
          bgImg: step03,
          title: "项目实施",
          description: "组建项目团队，完成 UI 设计、功能开发、测试部署与上线交付，确保项目稳定落地。",
          buttons: ["开发实施", "上线交付"]
        },
      ],
      observer: null,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1,
        },
      );

      this.observer.observe(this.$el);
    },
  },
};
</script>

<style scoped lang="scss">
.openingSteps {
  width: 100%;
  padding: 40px 16px;
}

.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.main-title {
  font-weight: 600;
  font-size: 20px;
  color: #111111;
  text-align: center;
  margin-bottom: 8px;
}

.sub-title {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  text-align: center;
  display: block;
  width: 100%;
  margin-bottom: 24px;
}

.step-card {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  width: 100%;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 8px 50px 0px rgba(29,95,235,0.15);
  }
}

.step-card-title {
  font-weight: 600;
  font-size: 20px;
  color: #111111;
  margin-top: 24px;
}

.step-card-desc {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 1.8;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .openingSteps {
    padding: 40px 16px;
  }
  
  .step-card {
    width: 100% !important;
  }
}
</style>
